import { z } from 'zod';
import { IsoDateSchema } from './common.js';
/**
 * Period keys: calendar years as 'YYYY', then the named windows. Calendar years start at
 * FIRST_CALENDAR_YEAR; CY2020 is held but excluded from growth (Luminate coverage break).
 */
export const NAMED_PERIOD_KEYS = ['ytdPrior', 'ytd', 'ltmPrior', 'ltm', 'l3y', 'l5y'];
export const PeriodKeySchema = z.string().regex(/^(\d{4}|ytdPrior|ytd|ltmPrior|ltm|l3y|l5y)$/);
export const PeriodSchema = z.object({
    key: PeriodKeySchema,
    label: z.string(),
    start: IsoDateSchema,
    end: IsoDateSchema,
    /** The period this one is compared with for YoY, when any. */
    comparedTo: PeriodKeySchema.optional(),
    /** Calendar days in the period. */
    days: z.number().int().positive(),
});
export const GrowthKeySchema = z.string().regex(/^(\d{4}|ytd|ltm|cagr|car)$/);
export const GrowthColumnSchema = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal('yoy'),
        key: GrowthKeySchema,
        label: z.string(),
        vs: PeriodKeySchema,
    }),
    z.object({
        kind: z.literal('compound'),
        key: GrowthKeySchema,
        label: z.string(),
        from: PeriodKeySchema,
        years: z.number().int().positive(),
    }),
]);
/** Constants of the sheet. */
export const FIRST_CALENDAR_YEAR = 2020;
export const FIRST_GROWTH_YEAR = 2021; // CY2020 excluded: coverage break
export const YOY_FROM_YEAR = 2022;
export const CAGR_BASE_YEAR = 2021;
export const CAR_BASE_YEAR = 2023;
export const COMPOSITION_START_MONTH = '2019-01';
export const DAILY_MATRIX_START = '2019-01-08';
//# sourceMappingURL=periods.js.map